import React, { useState, useEffect } from "react";
import commonStyles from "../../../../styles/common/CommonStyles.module.scss";
import styles from "./ReleaseStyles.module.scss";
import Button from "@mui/material/Button";
import MarketPreferencesClient from "../../../../shared/clients/MarketPreferencesClient";
import HasPermissionTo from "../../../../common/HasPermissionTo";

function ReservationRelease(props) {
  const [releaseStatus, setReleaseStatus] = useState(false);
  const [renderApp, setRenderApp] = useState(false);

  useEffect(() => {
    let releaseStatus = false;
    props.hideOrShow(true);
    MarketPreferencesClient.getReservationReleaseStatus(props.user)
      .then((data) => {
        releaseStatus = data.result.status;
      })
      .finally(() => {
        props.hideOrShow(false);
        setRenderApp(true);
        setReleaseStatus(releaseStatus);
      });
  }, []);

  function setReleaseFlag(releaseFlag) {
    const marketPreferences = {
      releaseOrderEnable: releaseFlag,
    };

    props.hideOrShow(true);
    MarketPreferencesClient.saveReservationReleasePreferences(
      props.user,
      marketPreferences
    )
      .then(() => {
        setReleaseStatus(releaseFlag);
      })
      .finally(() => {
        props.hideOrShow(false);
      });
  }

  return (
    renderApp && (
      <div className="pagePadding">
        <p className={commonStyles.subHeader}>
          {props.t("ReservationRelease.subHeader")}
        </p>

        <div className={styles.releaseBtn}>
          <HasPermissionTo
            perform={["reservationRelease:write"]}
            permissions={props.user.permissions.rolePermissions}
            render={() => (
              <Button
                data-testid="releaseBtn"
                disabled={releaseStatus}
                variant="contained"
                onClick={() => {
                  setReleaseFlag(true);
                }}
                className={commonStyles.greenBtn}
                component="button"
              >
                <span>{props.t("ReservationRelease.publish")}</span>
              </Button>
            )}
            noRender={() => (
              <Button
                data-testid="releaseBtn"
                disabled={true}
                variant="contained"
                className={commonStyles.greenBtn}
                component="button"
              >
                <span>{props.t("ReservationRelease.publish")}</span>
              </Button>
            )}
          />
        </div>
      </div>
    )
  );
}

export default ReservationRelease;
